<template>
  <v-row class="grey-datepicker mx-0">
    <v-col align-center justify-space-between>
      <v-menu
        v-model="menu2"
        :close-on-content-click="false"
        :nudge-left="0"
        :nudge-bottom="5"
        offset-y
        width="303px"
        height="52px"
      >
        <template v-slot:activator="{ on }">
          <label
            v-on="on"
            class="showDate"
            :data-test-id="`${dataTestId}__date-picker__label`"
          >
            <span>{{ visibleSelectedDate }}</span>
            <v-icon class="ml-1 icon-top4 float-right">expand_more</v-icon>
          </label>
        </template>
        <v-date-picker
          v-model="date"
          :max="getLastDate"
          min="2013-01-01"
          background-color="rgb(229, 229, 229) !important"
          @input="handleDateChangeRequest"
          @change="menu2 = false"
          no-title
          color="#58E2C2"
          class="datepickerPanel"
          :data-test-id="`${dataTestId}__date-picker`"
        ></v-date-picker>
      </v-menu>
    </v-col>
  </v-row>
</template>
<script>
import EventBus from '@/EventBus';

export default {
  props: {
    setDate: String,
    dataTestId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      date: new Date().toISOString().substr(0, 10),
      maxDate: new Date().toISOString().substr(0, 10),
      menu2: false
    };
  },
  methods: {
    handleDateChangeRequest() {
      const dateObj = this.applyFormatToDateTime(this.date);
      const updatedDate = dateObj.toISOString();
      EventBus.$emit('getUpdatedDataOnDateChange', updatedDate);
    }
  },
  computed: {
    visibleSelectedDate() {
      if (this.setDate) {
        return this.dateMonthYearDate(this.setDate);
      }
      return this.dateMonthYearDate(this.date);
    },
    getLastDate() {
      return this.getMaxDate();
    }
  },
  mounted() {
    if (this.setDate) {
      this.date = this.setDate;
    }
  }
};
</script>
<style scoped>
.v-menu__content {
  min-width: auto !important;
}
.grey-datepicker {
  height: 52px;
  background-color: rgb(238, 237, 237);
}
.showDate {
  justify-content: start;
  display: block;
  cursor: pointer;
}
</style>
